
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M9.203 9.87c5.42-1.52 10.61-.83 14.12 1.53s4.96 6.64 5.57 9.69c.61 3.05 2.59 6.71 8.47 7.94 5.88 1.22 8.7 4.04 10 7.33 1.3 3.28 1.91 9.77.46 11.83-2.06 1.6-6.87 5.49-12.74 4.12-5.88-1.37-9.16-5.23-10.61-7.99-1.45-2.76-1.98-8.03-10.53-11.01-8.55-2.98-8.85-11.45-8.93-12.74-.08-1.29.08-7.57 4.2-10.69l-.01-.01z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M16.723 11.94c.38.31.57.5.71.63m2.22 1.85c.88.8 3.89 3.55 4.73 6.64.84 3.09 1.95 7.1 5.42 9.16 3.47 2.06 8.01 3.47 9.54 4.96m14.78-11.75c-1.68-3.61-5.85-9.02-12.36-8.7-7.52.37-8.8 5.29-8.95 8.09-.15 2.8.84 4.37 1.38 5.16m20.54.54c-1.07 1.17-4.14 5.13-9.04 4.98"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M47.003 15.8c.3-.61.66-4.02.56-4.78-.66-.66-3.76-4.02-8.95-4.02-5.19 0-9.68 2.63-12.33 7.41"}})])
          )
        }
      }
    